import store from '../store'
const axios = require('axios')

const api = axios.create({
  baseURL: `https://api-corretores.idealizacidades.com.br`,
  // baseURL: `http://127.0.0.1:3004`,
  timeout: 1800000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

api.interceptors.request.use(async (config) => {
  const vuex = await localStorage.getItem('vuex')
  if (vuex) {
    const data = JSON.parse(vuex)
    config.headers.Authorization = `Bearer ${data.user.token}`
  }

  return config
}, (error) => {
  return Promise.reject(error)
})

api.interceptors.response.use((response) => {
  return response
}, async (error) => {
  try {
    const originalRequest = error.config
    if (error.response.data.error.name === 'E_UNAUTHORIZED_ACCESS' && !originalRequest._retry) {
      originalRequest._retry = true

      const vuex = await localStorage.getItem('vuex')
      if (vuex) {
        const vuexD = JSON.parse(vuex)
        const response = await api.put('/tokens', { token: vuexD.user.token })
        const { token } = response.data

        store.commit('setToken', token)
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        return api(originalRequest)
      }
    }

    return Promise.reject(error.response ? error.response.data.error : error)
  } catch (error) {
    return Promise.reject(error)
  }
})

export default api



// WEBPACK FOOTER //
// ./src/services/api.js